
import { project_list, erns_list, tissue_list, kit_list, subproject_list } from '../../../service/apis';
import { experiments_view } from '../../../service/apis';
import { checkRowFilled } from '../components/UtilSubmissionTable';

const config = window.config;

export const isSolveRDSelected = currentFormControls => {
    // Return True if a SolveRD Project is selected
    for (let row of currentFormControls){
        for (let column of row){
            if (column.id === "Projects"){
                if (column.value.includes('Solve-RD')){
                    return true;
                }
            }
        }
    }
    return false;
}

export const isAnyMonths12 = currentFormControls => {
    //Return True if 12 months are selected in any row
    for (let row of currentFormControls){
        for (let column of row){
            if (column.id === "months"){
                if (column.value === "12"){
                    return true;
                }
            }
        }
    }
    return false;
}

export const isErderaSelected = currentFormControls => {
    // Return True if an ERDERA Project is selected
    for (let row of currentFormControls){
        for (let column of row){
            if (column.id === "Projects"){
                if (column.value.includes('ERDERA')){
                    return true;
                }
            }
        }
    }
    return false;
}

export const addEmbargoPeriodReason = currentFormControls => {
    //Add Embargo Reason Period to all Form Rows
    for (let row of currentFormControls){
        row.splice(4,0,{id:"embargoPeriodReason",index:row[0].index, value:'',error:''})
    }
}

export const removeEmbargoPeriodReason = (currentFormControls,index) => {
    //Remove Embargo Period Reason from all Form Rows
    for (let row of currentFormControls){
        row.splice(index, 1);
    }
}

export const parseSelectServerSide = (items,formItem,fieldId,valueChecked="") => {
    //Check data comming from server side API and try to update form field with new values
    if (items.length > 0){
        formItem.valueIndex = {value:0, label:items[0][fieldId]};
        formItem.value = items[0][fieldId];
        if (formItem.value !== "" && fieldId === "report_id") {
            formItem.error = "";
        }
    } else {
        if (formItem.value === "" && fieldId === "report_id"){
            formItem.error = valueChecked + " does not exits or you are not allowed to use it.";
        }
    }
};

export const fetchHeadersList = async (currentHeaders,token,apiEndpoint) => {
    // Project List
    let res = await project_list(token, apiEndpoint);
    let data = await res.json();
    let headerProject = currentHeaders.find(item => item.id === "Projects")
    headerProject.selection = data.filter((item) => item.allow_submission == true).map(item =>item.project_title);
    headerProject.selection.unshift("----");
    // ERNs List
    res = await erns_list(token, apiEndpoint);
    data = await res.json();
    let headerErns = currentHeaders.find(item => item.id === "erns")
    headerErns.selection = data.map(item =>item.name);
    headerErns.selection.unshift("----");
    // Tissue List
    res = await tissue_list(token, apiEndpoint);
    data = await res.json();
    let headerTissues = currentHeaders.find(item => item.id === "tissues")
    headerTissues.selection = data.map(item =>item.name);
    headerTissues.selection.unshift("----");
    // Kit List
    res = await kit_list(token, apiEndpoint);
    data = await res.json();
    let headerKit = currentHeaders.find(item => item.id === "kits")
    headerKit.selection = data.map(item =>item.kit_name);
    headerKit.selection.unshift("----");
    
    return currentHeaders;
};

export const fetchSubprojectList = async (currentHeaders, currentFormControls, token, apiEndpoint) => {  
    // Insert Subprojects if not already in currentHeaders and set the position of insertion
    let positonInsertion = 0;
    if (!currentHeaders.find(item => item.id === "Subprojects")) {
        // Subproject list
        let res = await subproject_list(token,apiEndpoint);
        let data = await res.json();
        // Subroject header
        let headerSubproject = { 
            id:"Subprojects", title : "Subproject", inputType:"selectMultiple", 
            description:"Select if these samples belong to a specific subproject.",
            mandatory:false, selection : [], width: 220
        };
        for (let subproject of data){
            headerSubproject.selection.push(subproject.name);
        }
        headerSubproject.selection.unshift("----");
        // Insert Subprojects after projects
        positonInsertion = currentHeaders.findIndex(item => item.id === "Projects") + 1;
        currentHeaders.splice(positonInsertion,0,headerSubproject);
    } else {
        positonInsertion = currentHeaders.findIndex(item => item.id === "Subprojects");
    }
    // Insert CNAG BARCODE if not already in currentHeaders
    if (!currentHeaders.find(item => item.id === "cnag_barcode")) {
        let headerBarcode = { 
            id:"cnag_barcode", title : "CNAG Barcode", inputType:"text", 
            description:"CNAG Barcode that identifies the sample.", 
            mandatory:false, width: 250, selection : [] 
        };
        // Insert CNAG Barcode after Subproject
        currentHeaders.splice(positonInsertion+1,0,headerBarcode);
    }
    // Insert Subproject and  CNAG Barcode as inputs on formControls
    let ndx = 0;
    for (let row of currentFormControls) {
        // Insert Subproject if not already in currentHeaders
        if (!row.find(item => item.id === "Subprojects")) {
            row.splice(
                positonInsertion,
                0,
                {id:"Subprojects",index:ndx,value:[],error:'', options:[]}
            );
        }
        // Insert CNAG Barcode if not already in currentHeaders
        if (!row.find(item => item.id === "cnag_barcode")) {
            row.splice(
                positonInsertion+1,
                0,
                {id:"cnag_barcode",index:ndx,value:'',error:'', options:[]}
            );
        }
        ndx++;
    }
    return [currentHeaders, currentFormControls];
} 
   

export const validateLibraryStrategyForKit = (libraryStrategy, kit, kitList) => {
    // Check if protocols and non cdna omics are defined in config
    const protocols = (config && config.protocols) ? config.protocols : [];
    const nonCdnaOmics = (config && config.non_cdna_omics) ? config.non_cdna_omics : {};
    // Clean protocols from kit list
    const exomeKits = kitList.filter(kit => !protocols.includes(kit));
    // Validate library strategy based on kit selection
    if (kit && kit !== "----") {
        if (libraryStrategy === "WGS" && kit !== "WGS") {
            return "Library Strategy is WGS so Kit must be WGS.";
        }
        if (libraryStrategy === "WXS" && kit === "WGS") {
            return "Library Strategy is WXS so Kit can not be WGS.";
        }
        if (libraryStrategy in nonCdnaOmics) {
            const protocols_for_library_strategy = nonCdnaOmics[libraryStrategy];
            if (!protocols_for_library_strategy.includes(kit)) {
                return "Protocol or kit " + kit + " is not allowed for library strategy " + libraryStrategy + ".";
            }
        }
        else if (!exomeKits.includes(kit)) {
            return "Exome Kit " + kit + " is not a vaild one!";
        }
        return "";
    }
    if (kit === "----") {
        return "This field is required.";
    }
    if (!exomeKits.includes(kit)) {
        return "Exome Kit " + kit + " is not a vaild one!";
    }
    return "";
};

export const validateKitForLibraryStrategy = (libraryStrategy, kit, libraryStrategyList) => {
    // Check if protocols and non cdna omics are defined in config
    const protocols = (config && config.protocols) ? config.protocols : [];
    const nonCdnaOmics = (config && config.non_cdna_omics) ? config.non_cdna_omics : {};
    // Validate kit based on library strategy selection
    if (kit) {
        if (kit === "WGS" && libraryStrategy !== "WGS") {
            return "Kit is WGS so Library Strategy must be WGS.";
        }
        if (libraryStrategy in nonCdnaOmics) {
            const protocols_for_library_strategy = nonCdnaOmics[libraryStrategy];
            if (!protocols_for_library_strategy.includes(kit)) {
                return "Protocol or kit " + kit + " is not allowed for library strategy " + libraryStrategy + ".";
            }
        }
        else if (!libraryStrategyList.includes(libraryStrategy)) {
            return "Library Strategy " + libraryStrategy + " does not exists!";
        }
        return "";
    }
    if (!libraryStrategyList.includes(libraryStrategy)) {
        return "Library Strategy " + libraryStrategy + " does not exists!";
    }
    return "";
};

const validateExperiment = async (groupOwner, participant, localExperimentId, token, apiEndpoint) =>  {
    // 1. Define return message
    let errorMessage = "";
    // 2. Check field does not have white spaces
    if (localExperimentId.includes(" ")) {
        errorMessage = "White spaces are not allowed. "
    } else {
        errorMessage = "";
    }
    // 3. Query If it exists any experiment for the group Owner with the same Local Experiment ID
    let data_query = {
        "page" : 1, "pageSize" : 1000, 
        "fields" : ["LocalExperimentID"],
        "filtered":[{"id":"LocalExperimentID","value":[localExperimentId]},{"id":"Owner","value":[groupOwner]}]
    }
    let response = await experiments_view(token,apiEndpoint, JSON.stringify(data_query))
    let data = await response.json();
    let exactHits = data["items"].filter(item => item.LocalExperimentID === localExperimentId).length;
    if (exactHits > 0 ) {
        errorMessage += "LocalExperimentID "+ localExperimentId +" already used for group " + groupOwner + " ";
    }
    else {
        errorMessage += "";
    }
    // 4. Query if it exists any experiment for the Participant_ID with the same Local Experiment ID
    data_query = {
        "page" : 1, "pageSize" : 1000, 
        "fields" : ["LocalExperimentID"],
        "filtered":[{"id":"LocalExperimentID","value":[localExperimentId]},{"id":"Participant_ID","value":[participant]}]
    }
    response = await experiments_view(token,apiEndpoint,JSON.stringify(data_query))
    data = await response.json();
    exactHits = data["items"].filter(item => item.LocalExperimentID === localExperimentId).length;
    if (exactHits > 0 ) {
        errorMessage += "LocalExperimentID "+ localExperimentId +" already used for participant " + participant;
    }
    else {
        errorMessage +="";
    }
    // 5. Return error string
    return errorMessage;
}

export const validateForm = async (formControls, headers, experimentOwner, token, apiEndpoint) => {
    //Loop Form Controls
    const libraryStrategyList = headers.find(item => item.id === "LibraryStrategy").selection;
    let kitList = headers.find(item => item.id === "kits").selection;
    for (let row of formControls){
        let checkRow = checkRowFilled(row, headers);
        for (let column of row){
            if (checkRow) {
                const value = column.value;
                //1. Check if the field is mandatory
                let columnHeader = headers.find(item => item.id === column.id);
                //1.0 Special case Embargo Period Reason
                if (column.id === "embargoPeriodReason") {
                    let fieldMonths = row.find(item => item.id === "months");
                    if (fieldMonths.value === "12" && column.value === "")  column.error = "This field is required.";
                    else column.error = "";
                }
                //1.1 Special case Local Experiment
                else if(column.id === "Experiment") {
                    //1.1.1 Get Participant Field
                    let participant = row.find(item => item.id === "Participant_ID").value;
                    let localExperimentId = value;
                    column.error = await validateExperiment(experimentOwner, participant, localExperimentId, token, apiEndpoint);
                }
                //1.3 Special case Library Strategy
                else if(column.id === "kits") {
                    //1.3.1 Get Library Strategey Field
                    let libraryStrategy = row.find(item => item.id === "LibraryStrategy").value;
                    //1.3.2 Get Kit Value
                    let kit = row.find(item => item.id === "kits").value;
                    //1.3.3 Check Library and Kit using helper method
                    column.error = validateLibraryStrategyForKit(libraryStrategy, kit, kitList);
                    //1.3.4 Kit is Mandatory
                    if (kit === "") column.error = "This field is required.";
                }
                //1.4 Special case Kits
                else if (column.id === "LibraryStrategy") {
                    //1.4.1 Get Library Strategy and Kit field
                    let libraryStrategy = row.find(item => item.id === "LibraryStrategy").value;
                    let kit = row.find(item => item.id === "kits").value;
                    //1.4.2 Check Library and Kit using helper method
                    column.error = validateKitForLibraryStrategy(libraryStrategy, kit, libraryStrategyList);
                    //1.4.3 Library Strategy is Mandatory
                    if (libraryStrategy === "" || libraryStrategy === "----") column.error = "This field is required.";
                }
                else if (columnHeader.mandatory) {
                    if (Array.isArray(value)) {
                        //Check if selected values are valid options
                        let wrongValues = "";
                        for (let item of value) {
                            if(columnHeader.selection.indexOf(item) === -1 && item !== ""){
                                  wrongValues = wrongValues + " " + item;
                                  column.value.splice(column.value.indexOf(item), 1);
                            }
                        }
                        //Report errors
                        if (value.length === 0 || (value.length === 1 && (value[0] === "----" || value[0] === "")))
                        {
                            column.error = "This field is required.";
                        }
                        else if (wrongValues !== "") {
                            column.error = wrongValues + " not a valid options!!";
                        }
                        else {
                            column.error = "";
                        }
                    }
                    else {
                        //Check in case of Combobox if selected value is valid
                        if (value === "" || value === "----")
                        {
                            if (column.error === "" ) {
                                column.error = "This field is required.";
                            }
                        }
                        else if(columnHeader.selection.length > 1 && columnHeader.selection.indexOf(value) === -1) {
                            column.error = value + " is not a valid option!!";
                        }
                        else {
                            column.error = "";
                        }
                    }
                }
            }
            else {
                //If row is empty then clean old errors
                column.error = "";
            }
        }
    }
}   

export const getApiKey = rowId => {
    //From column ID to Management API key
    const keyLabels = [
        {key:"Experiment", label:"Submitter_ID"}, {key:"Projects", label:"project"}, {key:"months", label:"months_until_embargo"},
        {key:"tissues", label:"tissue"}, {key:"erns", label:"erns"}, {key:"LibraryStrategy", label:"library_strategy"},
        {key:"kits", label:"kit"}, {key:"EGA", label:"EGA_ID"}, {key:"LibraryIsize", label:"read_insert_size"},
        {key:"Subprojects", label:"subproject"}
    ]
    let apiKey = keyLabels.find((item) => item.key === rowId);
    if (apiKey === undefined) return rowId;
    else return apiKey.label;
}
   
